import { Users } from 'lucide-react';
import { Label } from '@/components/ui/label';
import { VehicleCard } from '@/components/booking/VehicleCard';
import { VEHICLES } from '@/components/booking/bookingData';
import { bt } from '@/i18n/bookingI18n';

export function VehicleStep({ form, errors, set, lang = 'en' }) {
  const vehicles = VEHICLES[form.passengers] || [];
  const PASSENGER_OPTIONS = [
    { value: '3', label: bt(lang, 'upTo3'), sub: bt(lang, 'passSedan') },
    { value: '4', label: bt(lang, 'upTo4'), sub: bt(lang, 'passPremium') },
    { value: '6', label: bt(lang, 'upTo6'), sub: bt(lang, 'passSuvVan') },
  ];

  const getGridCols = (count) => {
    if (count === 1) return 'grid-cols-1 max-w-md mx-auto';
    if (count === 2) return 'grid-cols-1 sm:grid-cols-2';
    return 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3';
  };
  const gridCols = getGridCols(vehicles.length);

  return (
    <div data-testid="step-vehicle" className="animate-fade-in">
      <h2 className="font-heading font-black text-2xl sm:text-3xl text-[#121212] tracking-tight mb-2 text-center">{bt(lang, 'vehTitle')}</h2>
      <p className="font-body text-sm text-[#666666] text-center mb-8 sm:mb-10">{bt(lang, 'vehSub')}</p>

      <div className="max-w-2xl mx-auto mb-8">
        <Label className="font-heading text-xs tracking-wider text-[#121212] uppercase mb-3 block">{bt(lang, 'numPassengers')}</Label>
        <div className="grid grid-cols-3 gap-3">
          {PASSENGER_OPTIONS.map((opt) => (
            <button key={opt.value} type="button" data-testid={`passengers-${opt.value}`}
              onClick={() => { set('passengers', opt.value); set('vehicle', ''); }}
              className={`p-4 rounded-xl border text-center transition-all duration-300 ${form.passengers === opt.value ? 'border-[#EE5A01] bg-[#FFF4ED]' : 'border-black/10 bg-white hover:border-[#EE5A01]/40'}`}>
              <Users className={`w-5 h-5 mx-auto mb-2 ${form.passengers === opt.value ? 'text-[#EE5A01]' : 'text-[#666666]'}`} />
              <p className="font-heading font-bold text-sm text-[#121212]">{opt.label}</p>
              <p className="font-body text-[10px] text-[#666666] mt-0.5">{opt.sub}</p>
            </button>
          ))}
        </div>
        {errors.passengers && <p className="text-[#EE5A01] text-xs mt-2 font-body">{errors.passengers}</p>}
      </div>

      {form.passengers && vehicles.length > 0 && (
        <div className="max-w-4xl mx-auto">
          <div className={`grid gap-4 sm:gap-6 ${gridCols}`}>
            {vehicles.map((v) => (
              <VehicleCard key={v.name} vehicle={v} duration={form.duration} selected={form.vehicle} onSelect={(name) => set('vehicle', name)} lang={lang} />
            ))}
          </div>
          {errors.vehicle && <p className="text-[#EE5A01] text-xs mt-4 font-body text-center">{errors.vehicle}</p>}
        </div>
      )}
    </div>
  );
}
